import HoldingDocuments from "./holding-documents";

export default HoldingDocuments;
